import React from "react";
import {Button} from 'semantic-ui-react';
import FileUpload from "../../fileUpload/index";

const FileUploadBtn = () => {
    return ( 
        <FileUpload />
     );
}
 
export default FileUploadBtn;